import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ScannerPage from './pages/ScannerPage';
import ScanResultPage from './pages/ScanResultPage';

const ScannerApp: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ScannerPage />} />
      <Route path="/scanner" element={<ScannerPage />} />
      <Route path="/scanner/:scanId" element={<ScanResultPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default ScannerApp;
